<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>افزودن اطلاعیه</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.news_title.val" :description="form.news_title.inv" label="عنوان اطلاعیه" />
                                </CCol>
                                <CCol sm="3">
                                    <label>تاریخ و زمان انتشار</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="form.published_at.val" type="datetime"></date-picker>
                                    <small class="form-text text-muted w-100">{{form.published_at.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <CTextarea v-model="form.news_text.val" :description="form.news_text.inv" label="متن اطلاعیه"
                                        @keyup.enter="access=false" rows="3" />
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary">افزودن</CButton>
                        </div>
                    </CCardBody>
                </CCard>
                <CCard v-show="$store.state.perms.can_view_news">
                    <CCardHeader>
                        <strong>اطلاعیه‌ها</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CRow>
                            <CCol col="12">
                                <CDataTable hover striped :items="news" :fields="fields"
                                    :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
                                    <template #news_title="data">
                                    <td>
                                        <CButton color="link" @click="news_text=data.item.news_text;news_text_modal=true">
                                        {{data.item.news_title}}
                                        </CButton>
                                    </td>
                                    </template>
                                    <template #action="data">
                                        <td v-if="$store.state.perms.can_delete_news">
                                            <template>
                                                <div class="flex-container">
                                                    <div @click="delete_modal=true;id=data.item.id"
                                                        v-c-tooltip.hover="'حذف'">
                                                        <CIcon name="cilTrash" size="lg"/>
                                                    </div>
                                                </div>
                                            </template>
                                        </td>
                                        <td v-else>---</td>
                                    </template>
                                </CDataTable>
                                <br>
                                <div> 
                                    <CPagination
                                    :activePage.sync="page"
                                    :pages="page_count"
                                    align="center"
                                    :doubleArrows="true"
                                    />
                                </div>
                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CModal
			title="دقت کنید"
			size="sm"
			color="danger"
			:show.sync="delete_modal"
			>
			<p>آیا برای حذف شناسه {{id}} اطمینان دارید؟</p>
			<template #footer>
				<CButton @click="delete_modal=false" color="secondary">خیر</CButton>
                <CButton @click="delete_row" color="danger">بله</CButton>
			</template>
		</CModal>
        <CModal
			title="متن اطلاعیه"
			size="lg"
			color="primary"
			:show.sync="news_text_modal"
			>
			<p v-html="news_text"></p>
			<template #footer>
				<CButton @click="news_text_modal=false" color="primary">بستن</CButton>
			</template>
		</CModal>
  </div>
</template>

<script>
import validator from '../mixins'
export default {
    mixins: { validator },
    data() {
        return {
            form: {
                news_title: { val: '', inv: '', v: { req: true, max: 512 } },
                news_text: { val: '', inv: '', v: { req: true, max: 2048 } },
                published_at: { val: '', inv: '', v: { req: true, max: 16 } },
            },
            disable: false,
            fields: [
                { key: 'news_title', label: 'عنوان' },
                { key: 'published_at', label: 'تاریخ انتشار' },
                { key: 'action', label: 'عملیات' },
            ],
            page: 1,
            page_count: 0,
            offset: 0,
            limit: 10,
            news: [],
            news_text_modal: false,
            news_text: '',
            delete_modal: false,
            id: 0,
            access: true,
        }
    },
    watch: {
        page: {
            handler() {
				this.get();
				window.scrollTo({top: 0, behavior: 'smooth'});
            }
        }
    },
    mounted(){
        this.get();
    },
    methods: {
        submit(){
            if(this.access){
                if(this.disable == false){
                    const data = new FormData();
                    for (const key in this.form){
                        if(key == 'published_at'){
                            data.set(key, this.$moment(this.form[key].val, 'jYYYY-jMM-jDD HH:mm').locale('es').format('YYYY-MM-DD HH:mm'));
                        } else if(key == 'news_text'){
                            data.set(key, this.form[key].val.replaceAll('\n', '<br>'));
                        } else {
                            data.set(key, this.form[key].val);
                        }  
                    }
                    this.axios.post('news/', data)
                        .then(() => {
                            this.$notify({
                                group: 'foo',
                                type: 'success',
                                text: 'افزودن با موفقیت انجام شد.'
                            });
                            for (const key in this.form){
                                this.form[key].val = '';
                            }
                            this.page = 1;
                            this.get();
                        })
                        .catch(() => {
                            this.$notify({
                                group: 'foo',
                                type: 'error',
                                text: 'خطا! لطفا مجددا تلاش کنید.'
                            });
                        })
                }
            }
            this.access = true;
        },
        get() {
            if (this.disable == false) {
                this.axios.get('news/'
                    + '?count=1')
                    .then(res => {
                        this.row_count = String(res.data.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if(res.data.count > this.limit){
                            this.page_count = Math.ceil(res.data.count / this.limit);
                        } else {
                            this.page_count = 1;
                        }
                        this.offset = 0;
                        if(this.page != 1){
                            this.offset = (this.page * this.limit) - this.limit;
                        }
                    })
                .finally(() => {
                    this.axios.get('news/'
                        + '?limit=' + this.limit
                        + '&offset=' + this.offset)
                        .then(res => {
                            res.data.map(val => {
                                val.published_at = this.$moment(val.published_at, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
                            });
                            this.news = res.data;
                        })
                })
            }
        },
        delete_row() {
			this.axios.delete('news/'
			+ this.id)
			.then(() => {
				this.$notify({
					group: 'foo',
					type: 'success',
					text: 'حذف با موفقیت انجام شد.'
                });
				this.delete_modal = false;
				this.get();
			})
			.catch(() => {
				this.$notify({
					group: 'foo',
					type: 'error',
					text: 'خطا! لطفا مجددا تلاش کنید.'
                });
                this.delete_modal = false;
			})
		},
    },
    beforeCreate() {
        if(this.$store.state.perms.can_add_news == false
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
    }
}
</script>
